'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$00249 from "./presto.-Agent-View$$anon$9.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dClosed$0024 from "./presto.-Agent-View$-Closed$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$8() {
  this.aA2 = null;
  this.azU = null;
  this.azV = false;
  this.aA3 = null;
  this.aA4 = false;
  this.aA7 = null;
  this.aA0 = null;
  this.aA1 = false;
  this.azW = null;
  this.azX = false;
  this.azY = null;
  this.azZ = false;
  this.aA5 = false;
  this.aA6 = false;
  this.aA2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aA7 = "Closed";
}
export { $c_Lpresto_AgentView$$anon$8 as $c_Lpresto_AgentView$$anon$8 };
$p = $c_Lpresto_AgentView$$anon$8.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$8;
/** @constructor */
function $h_Lpresto_AgentView$$anon$8() {
}
export { $h_Lpresto_AgentView$$anon$8 as $h_Lpresto_AgentView$$anon$8 };
$h_Lpresto_AgentView$$anon$8.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aA2;
});
$p.M = (function() {
  if ((!this.azV)) {
    this.azU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.azV = true;
  }
  return this.azU;
});
$p.O = (function() {
  if ((!this.aA4)) {
    this.aA3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aA4 = true;
  }
  return this.aA3;
});
$p.E = (function() {
  return this.aA7;
});
$p.t = (function() {
  if ((!this.aA1)) {
    this.aA0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.aA1 = true;
  }
  return this.aA0;
});
$p.N = (function() {
  if ((!this.azX)) {
    this.azW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.azX = true;
  }
  return this.azW;
});
$p.Q = (function() {
  if ((!this.azZ)) {
    this.azY = new $j_presto$002e$002dAgent$002dView$0024$0024anon$00249.$c_Lpresto_AgentView$$anon$9();
    this.azZ = true;
  }
  return this.azY;
});
$p.v = (function() {
  if ((!this.aA6)) {
    this.aA5 = false;
    this.aA6 = true;
  }
  return this.aA5;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee64) => ((p) => \u03b4scrutinee64))($j_presto$002e$002dAgent$002dView$0024$002dClosed$0024.$m_Lpresto_AgentView$Closed$())));
});
var $d_Lpresto_AgentView$$anon$8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$8, "presto.AgentView$$anon$8", ({
  Ea: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$8 as $d_Lpresto_AgentView$$anon$8 };
//# sourceMappingURL=presto.-Agent-View$$anon$8.js.map
